<div class="panel panel-default">
  <a class="button-close" (click)="closeDialog()">
    <i class="material-icons fill-nightfall">
      close
    </i>
  </a>
  <ngb-tabset #tabs [activeId]="activeTabId">
    <!-- Tab 1 -->
    <ngb-tab title="Monthly commission" id="monthly_commission">
      <ng-template ngbTabContent>
        <np-table-monthly-commision [filter]="TAB_DATAS.monthly_commission"> </np-table-monthly-commision>
      </ng-template>
    </ngb-tab>
    <!-- End Tab 1 -->

    <!-- Tab 2 -->
    <ngb-tab title="Recent activity" id="recent_activity">
      <ng-template ngbTabContent>
        <np-table-most-recent-activity></np-table-most-recent-activity>
      </ng-template>
    </ngb-tab>
    <!-- End Tab 2 -->

    <!-- Tab 3 -->
    <ngb-tab title="Leads" id="leads">
      <ng-template ngbTabContent>
        <np-table-leads></np-table-leads>
      </ng-template>
    </ngb-tab>
    <!-- End Tab 3 -->

    <!-- Tab 4 -->
    <ngb-tab title="Traded accounts" id="traded_account">
      <ng-template ngbTabContent>
        <np-table-traded-account></np-table-traded-account>
      </ng-template>
    </ngb-tab>
    <!-- End Tab 4 -->

    <!-- Tab 5 -->
    <ngb-tab title="In sales process" id="in_sales_process">
      <ng-template ngbTabContent>
        <np-table-in-sales-process [filter]="TAB_DATAS.in_sales_process"></np-table-in-sales-process>
      </ng-template>
    </ngb-tab>
    <!-- End Tab 5 -->

    <!-- Tab 6 -->
    <ngb-tab title="Converted" id="converted">
      <ng-template ngbTabContent>
        <np-table-referral-converted [filter]="TAB_DATAS.converted"></np-table-referral-converted>
        <np-table-ratio-converted [filter]="TAB_DATAS.converted"></np-table-ratio-converted>
      </ng-template>
    </ngb-tab>
    <!-- End tab 6 -->

  </ngb-tabset>
</div>